import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19 0H3C1.3 0 0 1.271 0 2.933v5.865c0 5.964 4.9 10.754 11 10.754s11-4.79 11-10.753V2.933C22 1.271 20.7 0 19 0m1 8.799c0 4.887-4 8.798-9 8.798s-9-3.91-9-8.799V2.933c0-.587.4-.978 1-.978h16c.6 0 1 .391 1 .978zm-5.7-1.663L11 10.363 7.7 7.136a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.368l4 3.91c.2.196.5.294.7.294s.5-.098.7-.293l4-3.91a.93.93 0 0 0 0-1.37.98.98 0 0 0-1.4.001"
    }, null, -1)
  ]))]))
}
export default { render: render }